import AutomationLookup from './automation-lookup';
import MavenPolicies from './maven-policies';
import MavenFeatures from './maven-features';
import MavenKeys from './maven-keys';
import MavenContext from './maven-context';
import MavenConfig from './maven-config';
import MavenAnalytics from './maven-analytics';
import Auth from './auth';
import Account from './account';
import PolicyBillingMetric from './billing-metric';
import FaasData from './faas-data';
import CcsV2 from './ccs-v2';
import LaunchDarkly from './launch-darkly';

class Api {
  constructor() {
    const baseURL = process.env.REACT_APP_API_URL;

    // This list will be fetched from the backend in the future
    const channels = ['lp_sms', 'lp_web', 'lp_inapp', 'lp_whatsapp', 'lp_rcs', 'lp_abc', 'twilio_sms', 'lp_fb', 'lp_viber'];
    const orchestratorContext = ['orchestrator.intent', 'orchestrator.channel', 'orchestrator.phoneNumber'];

    this.auth = new Auth({ baseURL });

    this.automationLookup = new AutomationLookup({
      baseURL: `${baseURL}/automationlookup`,
    });
    this.mavenPolicies = new MavenPolicies({
      baseURL: `${baseURL}/mavenpolicies/v1`,
    });
    this.mavenKeys = new MavenKeys({
      baseURL: `${baseURL}/mavenconfig/v1`,
    });
    this.mavenFeatures = new MavenFeatures({
      baseURL: `${baseURL}/switches`,
    });
    this.mavenContext = new MavenContext({
      baseURL: `${baseURL}/mavencontext/v1`,
    });
    this.mavenConfig = new MavenConfig({
      baseURL: `${baseURL}/mavenconfig/v1`,
    });
    this.mavenAnalytics = new MavenAnalytics({
      baseURL: `${baseURL}/mavenanalytics/v1`,
    });
    this.policyBillingMetric = new PolicyBillingMetric({
      baseURL: `${baseURL}/v2/account`,
    });
    this.faasData = new FaasData({
      baseURL: `${baseURL}/v2/account`,
    });
    this.account = new Account({
      baseURL: `${baseURL}/v2/account`,
    });
    this.ccsV2 = new CcsV2({
      baseURL: `${baseURL}/v2/account`,
    });
    this.launchDarkly = new LaunchDarkly({
      baseURL: `${baseURL}/v2/account`,
    });
    // TODO: replaced this with an API class to fetch data from the backend.
    this.getChannels = () => channels;

    // TODO: replaced this with an API class to fetch data from the backend.
    this.getOrchestratorContext = () => orchestratorContext;
  }
}

export default new Api();
